import BaseService from "../CorBase/BaseService";
import BaseFilter from '../CorBase/BaseFilter';
import { AxiosResponse } from "axios";

export class AccountMovementService extends BaseService{
	constructor() {
		super('/AccountMovement');
	}

	public getAllByFilter(filter: AccountMovementFilter) {
		return super.getAllByFilterBase(filter);
	}

	public getAllItemsByFilter(filter: AccountMovementFilter) {
		return super.getAllByFilterBase(filter,'all');
	}

	public getSumByFilter(filter: AccountMovementSumFilter) {
		return super.getAllByFilterBase(filter, 'summary');
	}

	public importFile(file: any) {
		return super.updateBase(this._resourceName + '/import-file/', file);
	}

	public importFileValidation(file: any) {
		return super.updateBase(this._resourceName + '/import-file-validation/', file);
	}

	public repayment(data: any) {
		return super.updateBase(this._resourceName + '/repayment/', data);
	}

	public repaymentRegenerate(data: any) {
		return super.updateBase(this._resourceName + '/repayment-regenerate/', data);
	}

	//provedeni importu dat
	public importAction(data: any) {
		return super.updateBase(this._resourceName + '/import-action/', data);
	}

	public cancelImport(data: any) {
		return super.updateBase(this._resourceName + '/import-cancel/', data);
	}

	//public updateReceiverTag(id: number, tags: any) {
	//	return super.updateBase(this._resourceName + '/receiver-tag/' + id, tags);
	//}


	public getExcell(filter: AccountMovementFilter): Promise<AxiosResponse<any>> {
		return super.getFileByFilter(filter, 'generate-excell');
	}
}

export class AccountMovementFilter extends BaseFilter{
	constructor(id?: number | null, idAccount?: number | null, unassigned?: boolean | null, isFrozen?: boolean | null, isOwner?: boolean | null, idSchoolYear?: number | null, isDeleted?: boolean | null ) {
		super();
		this._id = id;
		this._idAccount = idAccount;
		this._unassigned = unassigned;
		this._isFrozen = isFrozen;
		this._isOwner = isOwner;
		this._idSchoolYear = idSchoolYear;
		this._isDeleted = isDeleted;
	}

	private _id?: number | null;
	private _idAccount?: number | null;
	private _unassigned?: boolean | null;
	private _isFrozen?: boolean | null;
	private _isOwner?: boolean | null;
	private _idSchoolYear?: number | null;
	private _isDeleted?: boolean | null;

	public getAllParams(): {} {
		let data = Object.assign({},
			(this._id != null ? { Id: this._id } : {}),
			(this._idAccount != null ? { IdAccount: this._idAccount } : {}),
			(this._unassigned != null ? { Unassigned: this._unassigned } : {}),
			(this._isFrozen != null ? { IsFrozen: this._isFrozen } : {}),
			(this._isOwner != null ? { IsOwner: this._isOwner } : {}),
			(this._idSchoolYear != null ? { IdSchoolYear: this._idSchoolYear } : {}),
			(this._isDeleted != null ? { IsDeleted: this._isDeleted } : {})
		);
		
		return data;
	};
}

export class AccountMovementSumFilter extends BaseFilter {
	constructor(idAccount?: number | null, toDate?: Date | null, idSchoolYear?: number | null) {
		super();
		this._toDate = toDate;
		this._idAccount = idAccount;
		this._idSchoolYear = idSchoolYear;
	}

	private _toDate?: Date | null;
	private _idAccount?: number | null;
	private _idSchoolYear?: number | null;

	public getAllParams(): {} {
		let data = Object.assign({},			
			(this._idAccount != null ? { IdAccount: this._idAccount } : {}),
			(this._toDate != null ? { ToDate: this._toDate } : {}),
			(this._idSchoolYear != null ? { IdSchoolYear: this._idSchoolYear } : {})
		);
		return data;
	};
}